<template>
  <container fluid>
    <CCard>
      <CCardBody>
        <span class="text-muted font-weight-bold">{{ title }}</span>
        <div @click="goToSalesProfit()" class="puntero mt-3">
          <i class="bi bi-graph-up-arrow h2 text-info mr-3"></i>
          <strong class="h4">Utilidad {{ formatter.format(profitMargin, 2) }}%</strong>
        </div>
        <div class="mt-3">
          <span>Valor de Ventas:</span>
          <strong class="text-s3green ml-1">$ {{ formatter.format(merchandiseValue, 2) }}M</strong>
        </div>
        <div>
          <span>Valor de Costos:</span>
          <strong class="text-warning ml-1">$ {{ formatter.format(costValue, 2) }}M</strong>
          <CProgress 
            class="mb-1" 
            color="warning" 
            size="xs"
            :value="profitMargin" 
          />
        </div>
        <div>
          <span>Valor Utilidad:</span>
          <strong class="text-info ml-1">$ {{ formatter.format(profitValue, 2) }}M</strong>
          <CProgress 
            class="mb-1" 
            color="info" 
            size="xs"
            :value="salesProfitShare" 
          />
        </div>
      </CCardBody>
    </CCard>

    <LoadingCover spinner="dotsbar" v-show="loading" />
  </container>
</template>
<script>
  import { formatter } from "@/general";
  import { dataCostoVentasDocumentos } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default {
    name: 'SalesProfitPanel',
    data() {
      return {
        formatter,
        loading: false,
        merchandiseValue: 0,
        costValue: 0,
        profitValue: 0,
        profitMargin: 0,
        salesProfitShare: 0
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      typeUtility: String,
      staffGroupId: String,
      employeeId: String,
      divisorValues: Number
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesAndCosts() {
        this.loading = true;

        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Tipo_Reporte": "T",
            "Tipo_Utilidad": this.typeUtility,
            "Id_GrupoPersonal": this.staffGroupId,
            "Id_Personal": this.employeeId
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.merchandiseValue = response[0].Valor_Mercancia / this.divisorValues;
          this.costValue = response[0].Valor_Costo / this.divisorValues;
          this.profitValue = response[0].Valor_Utilidad / this.divisorValues;
          this.profitMargin = response[0].Porcentaje_Utilidad;
          this.salesProfitShare = ((this.profitValue / this.merchandiseValue) * 100);
        } catch (error) {
          console.log(error)          
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.getDataSalesAndCosts();
    }
  }
</script>
